import all from "ramda/es/all";
import any from "ramda/es/any";
import assoc from "ramda/es/assoc";
import compose from "ramda/es/compose";
import converge from "ramda/es/converge";
import curry from "ramda/es/curry";
import hasPath from "ramda/es/hasPath";
import join from "ramda/es/join";
import map from "ramda/es/map";
import memoizeWith from "ramda/es/memoizeWith";
import mergeDeepLeft from "ramda/es/mergeDeepLeft";
import objOf from "ramda/es/objOf";
import omit from "ramda/es/omit";
import pathEq from "ramda/es/pathEq";
import pluck from "ramda/es/pluck";
import propOr from "ramda/es/propOr";
import reduce from "ramda/es/reduce";
export const memoizeWithPermissionKey = memoizeWith(compose(join('|'), map(({ id, attributes = [] })=>join('-')([
        id,
        ...pluck('key', attributes),
        ...pluck('value', attributes)
    ]))));
export const hasId = (permissions)=>({ id })=>hasPath([
            id
        ], permissions);
export const hasKey = (permissions, id)=>({ key })=>hasPath([
            id,
            'values',
            key
        ], permissions);
export const hasValue = (permissions, id)=>({ key, value })=>pathEq(value, [
            id,
            'values',
            key
        ], permissions);
export const hasPermissionByAllIds = (permissions)=>memoizeWithPermissionKey(all(hasId(permissions)));
export const hasPermissionByIds = (permissions)=>memoizeWithPermissionKey(any(hasId(permissions)));
export const hasPermissionByAllIdsAndKeys = (permissions)=>memoizeWithPermissionKey(all(({ id, attributes = [] })=>{
        return all(hasKey(permissions, id), attributes);
    }));
export const hasPermissionByIdsAndKeys = (permissions)=>memoizeWithPermissionKey(any(({ id, attributes = [] })=>any(hasKey(permissions, id), attributes)));
export const hasPermissionByAllIdsAndKeysAndValues = (permissions)=>memoizeWithPermissionKey(all(({ id, attributes = [] })=>all(hasValue(permissions, id), attributes)));
export const hasPermissionByIdsAndKeysAndValues = (permissions)=>memoizeWithPermissionKey(any(({ id, attributes = [] })=>any(hasValue(permissions, id), attributes)));
export const hasPermissionByWholeStructure = curry((permissions)=>memoizeWithPermissionKey(any(({ id, attributes })=>{
        if (attributes) {
            return any((attr)=>{
                if (attr.value) {
                    return hasValue(permissions, id)(attr);
                }
                return hasKey(permissions, id)(attr);
            }, attributes);
        }
        return hasId(permissions)({
            id
        });
    })));
export const flattenPermissions = (permissions)=>{
    return reduce((acc, perm)=>assoc(perm.permissionId, perm, acc), {}, permissions);
};
export const transformPermissions = converge(mergeDeepLeft, [
    omit([
        'permissions'
    ]),
    compose(objOf('permissions'), flattenPermissions, propOr([], 'permissions'))
]);
